var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"send"},[_c('subscribe-message-form',{attrs:{"belongs":"official_account"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }